export default __webpack_public_path__ + "static/media/homeAccents.c6b512a0.jpg";